import { 
    CoherenceHeader, 
    CoherencePanelSize, 
    NotificationListItem, 
    NotificationItemStatus, 
    CoherenceNotificationItemOnUpdate, 
    ListItemStatusType
} from '@coherence-design-system/controls';
import React, { useState } from 'react';
import { Link } from '@fluentui/react';
import { IUserProfile } from './DataModels/IUserProfile';
import { siteTitle } from './Constants/SiteConstants';

export interface IAdminPortalHeaderProps {
    userProfile: IUserProfile | undefined;
    userProfilePhotoLink: string | undefined;
    notificationItems: NotificationListItem[];
    logoutAction: () => void;
}

export function AdminPortalHeader(props: IAdminPortalHeaderProps) {
    const { notificationItems, userProfile, userProfilePhotoLink, logoutAction } = props;
    const [newNotificationCount, setNewNotificationCount] = useState(notificationItems.length);

    const _onDismiss = (ids: string[]): void => {
        // Implement dismiss logic here
    };

    const _userProfilePanelBody = (
        <>
            {'For issues regarding your account, please reach out to '}
            <Link href="mailto:partnerportalengg@microsoft.com">our engineering team</Link>
            {' for help.'}
        </>
    );

    const _updateItem: CoherenceNotificationItemOnUpdate = function (
        itemKey: string,
        dStatus: NotificationListItem['displayStatus'],
        rStatus?: NotificationItemStatus | ListItemStatusType
    ) {
        notificationItems.forEach((item) => {
            if (item.itemKey === itemKey) {
                if (item.status === 'unread') {
                    setNewNotificationCount((prevCount) => Math.max(prevCount - 1, 0));
                }

                item.displayStatus = dStatus;
                if (rStatus) {
                    item.status = rStatus as NotificationItemStatus;
                }
            }
        });
    };

    return (
        <CoherenceHeader
            headerLabel="header"
            appNameSettings={{
                label: siteTitle,
            }}
            farRightSettings={{
                profileSettings: {
                    buttonSettings: {
                        title: 'Profile',
                        ariaLabel: 'Profile',
                    },
                    panelSettings: {
                        fullName: userProfile?.displayName,
                        emailAddress: userProfile?.mail,
                        imageUrl: userProfilePhotoLink,
                        logOutLink: '#',
                        onLogOut: logoutAction,
                        body: _userProfilePanelBody,
                    },
                },
                notificationsSettings: {
                    buttonSettings: {
                        title: 'Notification',
                    },
                    panelSettings: {
                        titleText: 'Notifications',
                        isUndoDismissAllVisible: true,
                        items: notificationItems,
                        newNotifications: newNotificationCount,
                        onDismissMultiple: _onDismiss,
                        updateItem: _updateItem,
                        panelSize: CoherencePanelSize.medium,
                        backButton: {
                            text: 'Back',
                            ariaLabel: 'Back',
                        },
                    },
                },
            }}
        />
    );
}
